import React, { memo } from 'react'

function ListingPanelFallback({ alt }) {
  const src = `${process.env.PUBLIC_URL}/images/hero/hero-828.webp`
  return (
    <div className="listing-panel-fallback rounded-3 overflow-hidden w-100">
      <img
        src={src}
        alt={alt}
        width={828}
        height={427}
        loading="lazy"
        decoding="async"
        className="w-100 object-fit-cover"
        style={{ maxHeight: '320px' }}
      />
    </div>
  )
}

export default memo(ListingPanelFallback)
